'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useEffect, useSyncExternalStore } from 'react';
import { useTheme } from 'next-themes';
import { ProgressProvider } from '@bprogress/next/app';
type PropsType = {
  children: ReactNode;
};

// Hydration-safe mounted check using useSyncExternalStore
const emptySubscribe = () => () => {};
const getSnapshot = () => true;
const getServerSnapshot = () => false;
const AppProgressProvider = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    theme
  } = useTheme();
  const mounted = useSyncExternalStore(emptySubscribe, getSnapshot, getServerSnapshot);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp3, t1);
  const progressColor = mounted && theme === "dark" ? "#8d8d8d" : "#444444";
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      showSpinner: false,
      minimum: 0.1,
      easing: "ease",
      speed: 200,
      trickle: true,
      trickleSpeed: 200
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== progressColor) {
    t3 = <ProgressProvider color={progressColor} height="2px" options={t2} shallowRouting={true}>{children}</ProgressProvider>;
    $[2] = children;
    $[3] = progressColor;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default AppProgressProvider;
function _temp(mutation) {
  if (mutation.attributeName === "class") {
    const htmlElement = document.documentElement;
    if (htmlElement.classList.contains("bprogress-busy")) {
      setTimeout(() => {
        if (htmlElement.classList.contains("bprogress-busy")) {
          htmlElement.classList.remove("bprogress-busy");
        }
      }, 300);
    }
  }
}
function _temp2(mutations) {
  mutations.forEach(_temp);
}
function _temp3() {
  const observer = new MutationObserver(_temp2);
  observer.observe(document.documentElement, {
    attributes: true
  });
  return () => {
    observer.disconnect();
  };
}